module.exports = __webpack_public_path__ + "static/media/Namibia.a5772113.png";